import React, { useState } from 'react';
import { useAuth } from '../../store/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { Rocket, ShieldCheck, ArrowLeft, Eye, EyeOff } from 'lucide-react';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.message);
      setLoading(false);
    }
  };

  return (
    <div className="grid-bg" style={{ 
      height: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      background: 'radial-gradient(circle at center, #0B3D91 0%, #05070A 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div className="scanline" />
      
      {/* Back to Home Button */}
      <Link to="/" style={{
        position: 'absolute',
        top: '20px',
        left: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: '#00CEC9',
        textDecoration: 'none',
        fontSize: '12px',
        fontWeight: 'bold',
        letterSpacing: '1px',
        textTransform: 'uppercase',
        transition: 'opacity 0.2s',
        zIndex: 10
      }}>
        <ArrowLeft size={16} /> ABORT TO BASE
      </Link>

      <div className="mission-control-card crt-effect glow-border">
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <Rocket size={48} color="#E27B58" style={{ marginBottom: '10px' }} />
          <h2 style={{ margin: 0, letterSpacing: '2px', fontFamily: "'Orbitron', sans-serif" }}>OPPORTUNITY</h2>
          <p style={{ color: '#E27B58', fontSize: '12px', marginTop: '5px' }}>MISSION CONTROL LOGIN</p>
        </div>

        {error && <div style={{ color: '#ff7675', marginBottom: '15px', fontSize: '14px', textAlign: 'center', background: 'rgba(255, 118, 117, 0.1)', padding: '10px' }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '5px', opacity: 0.8 }}>IDENTIFICATION (EMAIL)</label>
            <input 
              type="email" 
              className="nasa-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div style={{ marginBottom: '25px' }}>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '5px', opacity: 0.8 }}>ACCESS CODE (PASSWORD)</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                className="nasa-input"
                style={{ paddingRight: '44px' }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Ocultar clave' : 'Mostrar clave'}
                title={showPassword ? 'Ocultar clave' : 'Mostrar clave'}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  color: '#00CEC9',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '4px',
                }}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <button 
            type="submit" 
            className="nasa-button" 
            style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}
            disabled={loading}
          >
            {loading ? 'VERIFYING...' : 'AUTHENTICATE'}
          </button>
        </form>

        <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '14px' }}>
          <span style={{ opacity: 0.7 }}>New personnel? </span>
          <Link to="/register" style={{ color: '#00CEC9', textDecoration: 'none' }}>Initiate Enrollment</Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
